import {queryString} from 'utilities/url';

export const TestModeParam = 'test_mode';

export function isTestMode() {
  const params = queryString.parse(location.search);
  const testMode = params[TestModeParam] || '';

  return testMode.trim().toLowerCase() === 'true';
}

export function disableTestMode() {
  const query = {...queryString.parse(location.search), [TestModeParam]: false};
  location.assign(
    `${location.origin}${location.pathname}?${queryString.stringify(query)}`
  );
}
